import type { FaireProductEntity } from "../../entity_types/product";

export const p_62vtgevtx2: FaireProductEntity = {
  token: "p_62vtgevtx2",
  type: "product",
  name: "Gold Pearl Square Pendant Necklace; Pearl Charm Necklace",
  brandToken: "b_n2jsjnhwd3",
  brandName: "Furano Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/69b3a01559a3118a658a394e59c91720a533e66db6864de0ec01e80fc1f26302.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/296e769b310855676b415d94c8fb76e01f2738a43ba457d1c646637d9191f6ef.jpeg",
    "https://cdn.faire.com/fastly/1f57ca0722b74c900cf0a082193aa7f6d2ff752f941d43341d106669026f9797.jpeg",
    "https://cdn.faire.com/fastly/efcc8587626de8de3f8e09e62791c4b6e51b1cc85739060aebc55a1622ab39c5.jpeg",
    "https://cdn.faire.com/fastly/889c600d48d79eb6511a07029b3a15d4b52828a7a5a9fe73feba289eb82dedd8.jpeg",
    "https://cdn.faire.com/fastly/5f0f947cc85119bbac25d0c907457f1151943c79bc57807d779aa8994ea4af23.jpeg",
  ],
  priceDollars: 11.99,
  description:
    "• Our jewelry is crafted with 18K Gold Plating on stainless steel for durability and elegance.\n\n• It is generally waterproof and can resist tarnishing for up to a year with regular wear.\n\n• We offer white labeling options, and all jewelry is shipped in basic plain plastic pouches.\n\n• Additionally, paper cards and gift boxes featuring our logos are available. Please message us if you would like to buy.\n\n• Based in Los Angeles, we ensure fast shipping, with orders processed within one to two business days.",
  tags: [],
  msrpDollars: 32.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:32.913Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
